import { IIntakeModel, IIntakePetModel, IntakeModel, IntakePetModel } from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from './serviceHelper';
import { ServiceMethodOptions } from './types';

export class IntakeService {
    private static baseUrl: string = '/api/intake/';
    private static publicUserHeader: any = {
        'vpca': '351BD313-2C19-442B-BC87-C69356EB59EF',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    };

    static tags = {
        getIntake: "getIntake",
        openIntake: "openIntake",
        updateIntake: "updateIntake",
        updateIntakePet: "updateIntakePet",

    }

    /**
     * Validates User that supplys email or phone number
     * @param data Contains Email and/or Phone
     * @returns
     */
    static getIntake = (intakePublicId: string, options?: ServiceMethodOptions): Promise<IntakeModel> => {
        return trackPromise(new Promise<IntakeModel>((resolve, reject) => {
            http(`${this.baseUrl}publicId/${intakePublicId}`).mergeOptions({ headers: this.publicUserHeader }).get<IIntakeModel>()
                .then((intake) => {
                    ServiceHelper.showSuccess("Intake Loaded", options);
                    resolve(new IntakeModel(intake));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to load intake", options);
                    reject(err);
                })
        }), this.tags.getIntake);
    };


    /**
     * Sets intake as opened to track who opened the intake and from what source
     * @param intakeId Intake Id
     * @param linkSource Source from where the intake was opened
     */
    static openIntake = (intakeId: number, linkSource: string, options?: ServiceMethodOptions): Promise<null> => {
        return trackPromise(new Promise<null>((resolve, reject) => {
            http(`${this.baseUrl}open/${intakeId}/${linkSource}`).mergeOptions({ headers: this.publicUserHeader }).post<null>({})
                .then(() => {
                    ServiceHelper.showSuccess("Intake Opened", options);
                    resolve(null);
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to open Intake", options);
                    reject(err);
                })
        }), this.tags.openIntake);
    };

    /**
     * Updates Intakes
     * @param intakeModel Intake Model to update
     * @param linkSource Link source used to determine what source the user came from
     * @returns Intake Model
     */
    static updateIntake = (intakeModel: IIntakeModel, linkSource: string, options?: ServiceMethodOptions): Promise<IntakeModel> => {
        return trackPromise(new Promise<IntakeModel>((resolve, reject) => {
            http(`${this.baseUrl}${linkSource}`).mergeOptions({ headers: this.publicUserHeader }).post<IIntakeModel>(intakeModel)
                .then((intake) => {
                    ServiceHelper.showSuccess("Intake Updated", options);
                    resolve(new IntakeModel(intake));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to update Intake", options);
                    reject(err);
                })
        }), this.tags.updateIntake);
    };

    /**
     * Updates Intake pets
     * @param intakePetModel Intake Pet Model to update
     * @param linkSource Link source used to determine what source the user came from
     * @returns Intake Pet Model
     */
    static updateIntakePet = (intakePetModel: IIntakePetModel, linkSource: string, options?: ServiceMethodOptions): Promise<IntakePetModel> => {
        return trackPromise(new Promise<IntakePetModel>((resolve, reject) => {
            http(`${this.baseUrl}pet/${linkSource}`).mergeOptions({ headers: this.publicUserHeader }).post<IIntakePetModel>(intakePetModel)
                .then((intakePet) => {
                    ServiceHelper.showSuccess("Intake Pet Updated", options);
                    resolve(new IntakePetModel(intakePet));
                })
                .catch((err) => {
                    ServiceHelper.showError("Failed to update Intake Pet", options);
                    reject(err);
                })
        }), this.tags.updateIntakePet);
    };
}
